
import { defineComponent } from "vue";
import { FilterMatchMode } from "primevue/api";
import ObjectCard from "@/components/furnituresView/ObjectCard.vue";

export default defineComponent({
  components: {
    ObjectCard,
  },
  data() {
    return {
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      gateways: [] as any[],
      isGrid: true,
      keyword: "",
      filteredGateways: [] as any[],
    };
  },
  methods: {
    connectedCount() {
      return this.gateways.filter(
        (gateway: any) => gateway.state == "REACHABLE"
      ).length;
    },
    unreachableCount() {
      return this.gateways.filter(
        (gateway: any) => gateway.state == "UNREACHABLE"
      ).length;
    },
    activeGrid() {
      this.isGrid = true;
    },
    activeList() {
      this.isGrid = false;
    },
    stateName(state: string) {
      if (state?.toLowerCase().trim() == "unreachable") {
        return "injoignable";
      } else if (state?.toLowerCase().trim() == "ok") {
        return "connecté";
      } else {
        return "inconnu";
      }
    },
    filtersGrid() {
      this.gateways = this.filteredGateways.filter(
        (gateway) =>
          gateway.name.toLowerCase().includes(this.keyword.toLowerCase()) ||
          gateway.brand.toLowerCase().includes(this.keyword.toLowerCase()) ||
          gateway.zone.toLowerCase().includes(this.keyword.toLowerCase()) ||
          gateway.state.toLowerCase().includes(this.keyword.toLowerCase())
      );
    },
  },
  async mounted() {
    const session = JSON.parse(localStorage.getItem("gatewaysinfo")!);
    if (session !== null && session.gateways) {
      this.gateways = session.gateways;
    } else {
      return {};
    }
    this.filteredGateways = this.gateways;
  },
});
